import {  KoDropdown, KoPagination, KoTable, KoText, KoTitle } from 'packages';
import React, { useState } from 'react';
import {PRO_ITEMS_COLUMNS, ROWS } from  "./constant";
import styles from './topproduct.module.scss';
import KoIcon from '@kwapio/icons';
const RecentProduct = () => {

  const [filter, setFilter] = useState("All Status");
  const [totalCount ] = useState(0);
  const [pagination, setPagination ] = useState({
    size: 100,
    page: 1
  });

  const onPagination = (page, other) => {
    const query = {
      size: other,
      page: page,
      offset: (page - 1) * other
    };
    const pQuery = Object.assign(pagination, query);
    setPagination(pQuery);
  };

  const filterStatus = [
    {
      key: "allstatus",
      label: "All Status"
    },
    {
      key: "success",
      label: "Success"
    },
    {
      key: "canceled",
      label: "Canceled"
    },
    {
      key: "pending",
      label: "Pending"
    }];
  const getFiterStatusData = ({ key }) => {
    let item = filterStatus.find((item) => item.key === key);
    setFilter(item?.label);
  };
    
  return (
    <div className={styles.recentProduct}>
      <div className={styles.headers}>
        <KoTitle level={5} text={'Recent Orders'}/>
        <div className={styles.statusSelection}>

          <KoDropdown
            placement="bottomRight"
            overlayClassName={"overlayClassName"}
            menu={{
              items: filterStatus,
              onClick: getFiterStatusData
            }}
          >
            <div className={styles.dropdown}>
              <KoText text={filter} />
              <KoIcon name={"DownArrowOutlined"} width={12} height={12} />
            </div>
          </KoDropdown>
        </div>
      </div>

      <div className={styles.table}>
        <KoTable
          maxHeight={40}
          data={{
            columns: PRO_ITEMS_COLUMNS,
            rows:
        filter === "All Status"
          ? ROWS
          : ROWS.filter((row) => row.status === filter)
          }}
        />
      </div>
      <KoPagination current={parseInt(pagination.page) || 1}
        total={totalCount}
        showTotal={(total, range) =>
              `${range[0]}-${range[1]} of ${total} records`
        }
        pageSize={pagination.limit}
        defaultCurrent={pagination.page}
        onChange={onPagination}
        showQuickJumper={false}
        simple={false}
        responsive={false} />
    </div>
  );
};

export default RecentProduct;